import React from 'react';

import { permissionRowPropType, permissionSectionPropType } from './permissionsData';
import SummaryCheckbox from './SummaryCheckboxContainer';
import { getRowDependencies } from './helpers';
import PermissionCheckbox from './PermissionCheckboxContainer';

const PermissionRow = ({ data, sectionData }) => (
  <div className="c-permissions--section-row">
    <div>
      <SummaryCheckbox dependencies={getRowDependencies(data)} />
    </div>
    <div className="c-permissions--permission-name">{data.rowTitle}</div>
    {['view', 'addEdit', 'book', 'modify', 'history', 'cancel', 'blockTime'].map(columnName => (
      <PermissionCheckbox
        key={`${data.rowId}-${columnName}`}
        permissionData={data.permissions[columnName]}
        showColumn={sectionData.showColumns.includes(columnName)}
      />
    ))}
  </div>
);

PermissionRow.propTypes = {
  data: permissionRowPropType.isRequired,
  sectionData: permissionSectionPropType.isRequired,
};

export default PermissionRow;
